import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from '../util/withRouter';
import moment from 'moment';

export function getRedirectUrl(props, from = '/') {
  if (!props.user.config || !props.user.config.exportEnabled) {
    return `/premium?from=${from}`;
  }

  if (!!props.user.config.exportTrialEnd) {
    if (moment(props.user.config.exportTrialEnd).diff(moment()) < 0) {
      return `/premium?from=${from}`;
    }
  }

  if (props.user.config.exportDeactivationDate && !props.user.config.exportEnabled) {
    return `/premium?from=${from}`;
  }
}

export default function(ComposedComponent) {
  class RequireActivePremium extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const redirectUrl = getRedirectUrl(this.props, this.props.location.pathname);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
      settings: state.report.settings,
      dashboards: state.dashboards.list,
      dashboardsLoaded: state.dashboards.loaded,
      dashboardsCount: state.auth.user.dashboards
    };
  }

  return withRouter(connect(mapStateToProps)(RequireActivePremium));
}
